"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _main = _interopRequireDefault(require("../templates/main"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("../../theme"));

var _getScrollWidth = _interopRequireDefault(require("../../../utils/getScrollWidth"));

var _react = _interopRequireDefault(require("react"));

var iosPattern = /iPhone|iPad/,
    iosVersion = /OS\s([\d_]+)\s/;
var SCROLL_WIDTH;

var Main =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Main, _Component);

  function Main(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "resize",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      var _this$state, scrollWidth, isIOS, offsetTop, offsetLeft, visible, h, w, viewPortWidth, viewPortHeight, vh, top, left;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.root.current || !_this.container.current)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _this$state = _this.state, scrollWidth = _this$state.scrollWidth, isIOS = _this$state.isIOS, offsetTop = _this$state.offsetTop, offsetLeft = _this$state.offsetLeft, visible = _this$state.visible, h = _this.container.current.offsetHeight, w = _this.container.current.offsetWidth, viewPortWidth = _this.root.current.offsetWidth - scrollWidth, viewPortHeight = _this.root.current.offsetHeight, vh = window.innerHeight;
              top = 0; // не ставить calc() или процентные значения. хром пересчитывает отступы с погрешностью из-за них

              if (h < vh) {
                top = Math.ceil(viewPortHeight / 2 - h / 2);
              }

              top = (top < 0 ? 0 : top) + 'px';
              left = Math.ceil(viewPortWidth / 2 - w / 2);
              left = left < 0 ? 0 : left + 'px';

              if (!(offsetTop !== top || offsetLeft !== left)) {
                _context.next = 12;
                break;
              }

              _context.next = 11;
              return _this.setState({
                offsetTop: top,
                offsetLeft: left,
                minWidth: isIOS ? w : null
              });

            case 11:
              // при первом появлении попапа нужно дождаться пока установятся начальные оффсеты
              // только потом показываем попап
              // иначе он ездит по экрану при установке начальных отступов
              if (!visible) {
                setTimeout(function () {
                  return _this.setState({
                    visible: true
                  });
                }, 150);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    SCROLL_WIDTH = SCROLL_WIDTH || (0, _getScrollWidth["default"])();
    _this.state = {
      offsetTop: null,
      offsetLeft: null,
      visible: false,
      minWidth: null,
      scrollWidth: SCROLL_WIDTH,
      isIOS: _this._isIOS()
    };
    _this.container = _react["default"].createRef();
    _this.root = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._resize();

      this._setDefaultScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(Main.prototype), "componentWillUnmount", this).call(this);
      clearInterval(this.resizeInterval);
    }
  }, {
    key: "_resize",
    value: function _resize() {
      clearInterval(this.resizeInterval);
      this.resizeInterval = setInterval(this.resize, 50);
    }
  }, {
    key: "_setDefaultScroll",
    value: function _setDefaultScroll() {
      if (this.state.isIOS) {
        var _window;

        (_window = window) === null || _window === void 0 ? void 0 : _window.scrollTo({
          top: 0,
          left: 0
        });
      }
    } // IOS < 11.3 не ресайзит viewport с fixed position при открытии виртуальной клавиатуры, из-за чего
    // ломается расположение элементов на странице
    // TODO REMOVE

  }, {
    key: "_isIOS",
    value: function _isIOS() {
      var _window2, _window2$navigator;

      var ua = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$navigator = _window2.navigator) === null || _window2$navigator === void 0 ? void 0 : _window2$navigator.userAgent;
      var result = false;

      if (iosPattern.test(ua)) {
        var version = iosVersion.exec(ua);

        if (version) {
          version = version[1].split('_');
        } // minor version


        if (version.length >= 2) {
          var major = +version[0],
              minor = +version[1];
          result = major < 11 || major === 11 && minor < 3;
        }
      }

      return result;
    }
  }]);
  return Main;
}(_Component2["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  closeAvailable: true,
  minOffsetTop: 80,
  minOffsetBottom: 80
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  closeAvailable: _propTypes["default"].bool,
  minOffsetTop: _propTypes["default"].number,
  minOffsetBottom: _propTypes["default"].number,
  onClose: _propTypes["default"].func
});
(0, _defineProperty2["default"])(Main, "displayName", 'PopupBase');

var _default = (0, _theme["default"])(Main, 'popup');

exports["default"] = _default;